import Cookies from 'js-cookie';

import { IGeoState } from '../../../shared/types/geo';

export function setLocationCookies({ cityId, cityName }: IGeoState) {
  Cookies.set('forever_region_id', String(cityId), { domain: '.cian.ru', expires: 365 });
  Cookies.set('session_region_id', String(cityId), { domain: '.cian.ru' });

  Cookies.set('forever_region_name', cityName, { domain: '.cian.ru', expires: 365 });
  Cookies.set('session_region_name', cityName, { domain: '.cian.ru' });
}
